import React from "react";
import { Input } from "semantic-ui-react";

const NumericalText = ({ field, fieldValue = "", updateIdea, isEditing, inputRef, handleKeyDown }) => {
  const { minValue, maxValue } = field;

  if (!isEditing) {
    return <span>{fieldValue}</span>;
  }

  return (
    <div>
      <Input
        fluid
        value={fieldValue}
        onChange={(e) => {
          let nextValue = parseFloat(e.target.value);

          if (isNaN(nextValue)) {
            nextValue = "";
          } else {
            //Checks that the value is within the bounds
            if (minValue !== undefined && nextValue < minValue) {
              nextValue = minValue; //Set to minimum value
            }
            if (maxValue !== undefined && nextValue > maxValue) {
              nextValue = maxValue; //Set to maximum value
            }
          }

          updateIdea(nextValue, ["templated", field.id]);
        }}
        ref={inputRef}
        readOnly={!isEditing}
        type="number"
        onKeyDown={(event) => handleKeyDown(event)}
      />
    </div>
  );
};

export default NumericalText;
